import React, { useEffect, useImperativeHandle } from 'react';
import { useUser } from '@reducers/user/hooks';
import { createEditQuestionSignatureRequest } from '../../AssessmentServiceAPI';
import { useGetSignature } from '../../Hooks/Query';
import { ItemBankWrapper } from '../ItemBankHarness/styles';

const containerId = 'learnosity_edit_question_container';
const EditQuestion = ({ widgetRef, eventHandlers, referenceId, setIsLoading }) => {
  const currentUser = useUser();
  const mainRef = React.useRef<HTMLDivElement>(null);
  const [widgetInstance, setWidgetInstance] = React.useState(undefined);
  const { data: signature } = useGetSignature(
    createEditQuestionSignatureRequest(referenceId, currentUser),
    'author',
    {
      enabled: !widgetInstance && !!(window as any).LearnosityAuthor,
    },
  );
  useImperativeHandle(widgetRef, () => ({ widgetInstance }), [widgetInstance]);

  useEffect(() => {
    mainRef.current!.appendChild(document.createElement('div')).id = containerId;
  }, []);

  useEffect(() => {
    if (!widgetInstance) {
      return;
    }
    widgetInstance?.navigate(`items/${referenceId}`);
  }, [referenceId]);

  useEffect(() => {
    if (!currentUser) {
      return;
    }
    const isElementOnTheDom = !!document.getElementById(containerId);
    if (Object.keys(signature!).length && !widgetInstance && isElementOnTheDom) {
      const author = (window as any).LearnosityAuthor?.init(
        signature,
        {
          readyListener: () => {
            console.log('Authoring API has been initialized');
            setWidgetInstance(author);
            setIsLoading?.(false);
          },
          errorListener: (error: any) => {
            console.error('Error initializing Authoring API', error);
          },
        },
        containerId,
      );
      if (eventHandlers) {
        eventHandlers.forEach(({ name, callback }) => {
          author.on(name, (...args: any[]) => {
            callback(author, args);
          });
        });
      }
    }
    return () => {
      if (widgetInstance && isElementOnTheDom) {
        widgetInstance.destroy(); // TODO this is not correct
        setWidgetInstance(undefined);
      }
    };
  }, [signature, widgetInstance, setIsLoading, currentUser, eventHandlers]);
  return (
    // TODO wrap in styles
    <ItemBankWrapper ref={mainRef} />
  );
};
export default EditQuestion;
